const http = require('core/http');
const config = require('core/config').resources.media;

module.exports = {
	// Get from S3 Media bucket
	get: function (path) {
		let host = config.cdn || config.origin;
		let url = host + path;

		return http
			.get(url)
			.then(function (response) {
				return JSON.parse(response.text);
			})
			.catch(function (error) {
				throw error;
			});
	}
};
